import { render, staticRenderFns } from "./AccountHeads.vue?vue&type=template&id=6608e36c&scoped=true&"
import script from "./AccountHeads.vue?vue&type=script&lang=js&"
export * from "./AccountHeads.vue?vue&type=script&lang=js&"
import style0 from "./AccountHeads.vue?vue&type=style&index=0&id=6608e36c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608e36c",
  null
  
)

export default component.exports